// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.security-lock {
  position: fixed;
  inset: 0;
  z-index: 10002;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: linear-gradient(
    26deg,
    #000000 0%,
    #4a4a4a 34%,
    #de4858 100%
  );
  font-family: 'Roboto', sans-serif;
  overflow-y: auto;
}

.security-lock__card {
  width: min(560px, 100%);
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
  padding: 32px;
  box-sizing: border-box;
  animation: securityLockAppear 0.25s ease-out;
}

@keyframes securityLockAppear {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.security-lock__icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(222, 72, 88, 0.12);
  color: var(--netsfere-red, #de4858);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px auto;
}

.security-lock__title-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.security-lock__title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: rgba(74, 74, 74, 1);
  text-align: center;
}

.security-lock__badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.security-lock__badge--critical {
  background: var(--netsfere-red, #de4858);
  color: #ffffff;
}

.security-lock__badge--recommended {
  background: #f4a300;
  color: #ffffff;
}

.security-lock__body {
  margin: 0 0 24px 0;
  font-size: 15px;
  line-height: 1.5;
  color: rgba(74, 74, 74, 1);
  text-align: center;
}

.security-lock__primary {
  display: block;
  width: 100%;
  height: 48px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  background-color: var(--netsfere-red, #de4858);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  transition: filter 0.15s ease-in-out;
}

.security-lock__primary:hover {
  filter: brightness(1.05);
}

.security-lock__primary:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.8);
  outline-offset: 2px;
}

.security-lock__details-toggle {
  margin-top: 16px;
  width: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(74, 74, 74, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 0;
}

.security-lock__details-toggle:hover {
  color: rgba(74, 74, 74, 1);
}

.security-lock__details {
  margin: 12px 0 0 0;
  padding: 16px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 6px 16px;
  font-size: 13px;
  color: rgba(74, 74, 74, 1);
}

.security-lock__details dt {
  font-weight: 600;
}

.security-lock__details dd {
  margin: 0;
  word-break: break-all;
}

.security-lock__details a {
  color: var(--netsfere-red, #de4858);
  text-decoration: underline;
}

@media (max-width: 480px) {
  .security-lock__card {
    padding: 24px;
  }
  .security-lock__title {
    font-size: 20px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .security-lock__card {
    animation: none;
  }
  .security-lock__primary {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SecurityUpdate/SecurityLockScreen.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB;;;;;GAKC;EACD,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".security-lock {\n  position: fixed;\n  inset: 0;\n  z-index: 10002;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n  background: linear-gradient(\n    26deg,\n    #000000 0%,\n    #4a4a4a 34%,\n    #de4858 100%\n  );\n  font-family: 'Roboto', sans-serif;\n  overflow-y: auto;\n}\n\n.security-lock__card {\n  width: min(560px, 100%);\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);\n  padding: 32px;\n  box-sizing: border-box;\n  animation: securityLockAppear 0.25s ease-out;\n}\n\n@keyframes securityLockAppear {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.security-lock__icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(222, 72, 88, 0.12);\n  color: var(--netsfere-red, #de4858);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px auto;\n}\n\n.security-lock__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.security-lock__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: rgba(74, 74, 74, 1);\n  text-align: center;\n}\n\n.security-lock__badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.security-lock__badge--critical {\n  background: var(--netsfere-red, #de4858);\n  color: #ffffff;\n}\n\n.security-lock__badge--recommended {\n  background: #f4a300;\n  color: #ffffff;\n}\n\n.security-lock__body {\n  margin: 0 0 24px 0;\n  font-size: 15px;\n  line-height: 1.5;\n  color: rgba(74, 74, 74, 1);\n  text-align: center;\n}\n\n.security-lock__primary {\n  display: block;\n  width: 100%;\n  height: 48px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  background-color: var(--netsfere-red, #de4858);\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: 'Roboto', sans-serif;\n  transition: filter 0.15s ease-in-out;\n}\n\n.security-lock__primary:hover {\n  filter: brightness(1.05);\n}\n\n.security-lock__primary:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.8);\n  outline-offset: 2px;\n}\n\n.security-lock__details-toggle {\n  margin-top: 16px;\n  width: 100%;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-family: 'Roboto', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(74, 74, 74, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 0;\n}\n\n.security-lock__details-toggle:hover {\n  color: rgba(74, 74, 74, 1);\n}\n\n.security-lock__details {\n  margin: 12px 0 0 0;\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 8px;\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  gap: 6px 16px;\n  font-size: 13px;\n  color: rgba(74, 74, 74, 1);\n}\n\n.security-lock__details dt {\n  font-weight: 600;\n}\n\n.security-lock__details dd {\n  margin: 0;\n  word-break: break-all;\n}\n\n.security-lock__details a {\n  color: var(--netsfere-red, #de4858);\n  text-decoration: underline;\n}\n\n@media (max-width: 480px) {\n  .security-lock__card {\n    padding: 24px;\n  }\n  .security-lock__title {\n    font-size: 20px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .security-lock__card {\n    animation: none;\n  }\n  .security-lock__primary {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
